module.exports = __webpack_public_path__ + "static/Symphonia0-c4056185249f8011a67ddfa533f93a5a.png";